export const appVersionKeys = {
  all: ["app", "version-manifest"] as const,
  manifest: () => [...appVersionKeys.all] as const,
};
